import { Trans } from "react-i18next"

import util from "utils/utils"

export default function Joined({ ownerGroup, events }) {
  return (
    <Trans
      i18nKey="notifications.groupUserJoined"
      values={{ name: util.getEventNames(events), group: ownerGroup?.name || "Deleted" }}
      components={{ b: <b /> }}
    />
  )
}
